/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { ApplicationContext } from '@contexts/ApplicationContext';
import { App_config } from './interfaces';
import { BootstrapApp } from './bootstrap';
import { VApplication } from './application';

import { logger } from '@common/logger';

const initAppInstance = async () => {
  await VApplication.getInstance().start();
  logger?.log(`🚀 Main Application Started 🚀`);
  return true;
};

function App() {
  const [selectedNamespace, setSelectedNamespace] = useState('');
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    Promise.all([
      //Add any bootstrap request here ( Ex. Server etc. )
      initAppInstance(),
    ])
      .then(async ([]) => {})
      .catch((e) => {})
      .finally(() => {
        setInitialized(true);
      });
  }, []);
  if (initialized) {
    return (
      <ApplicationContext.Provider
        value={{
          selectedNamespace,
          setSelectedNamespace,
          appId: App_config.appId,
          appName: App_config.appName,
        }}
      >
        <BootstrapApp />
      </ApplicationContext.Provider>
    );
  }
  return <></>;
}

export default App;
